import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export function MarketingCta() {
  return (
    <section className="container mx-auto px-4 py-20">
      <div className="max-w-4xl mx-auto text-center p-12 rounded-2xl bg-primary/5 border border-primary/20">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">Ready to Transform Your Library?</h2>
        <p className="text-lg text-muted-foreground mb-8">
          Join institutions worldwide using PhiloLMS to modernize their library operations.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button size="lg" asChild>
            <Link to="/onboard">Start Your Free Trial</Link>
          </Button>
          <Button size="lg" variant="outline" asChild>
            <a href="#contact">Talk to us</a>
          </Button>
        </div>
      </div>
    </section>
  );
}
